exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#render-window[data-v-4d218c2c]{position:fixed;top:0;left:0;width:100%;height:100%;transition:all .2s ease;background-color:#f0f8ff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d218c2c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SpeckleRenderer.vue
// module id = 438
// module chunks = 0